function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': `application/${type}`}
    };
}

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

$('.js-sort-by').on('change', function () {
    const selectedValue = this.options[this.selectedIndex];
    Shopify.queryParams = {};
    if (location.search.length) {
        var params = location.search.substr(1).split('&');

        for (var i = 0; i < params.length; i++) {
            var keyValue = params[i].split('=');

            if (keyValue.length) {
                Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
            }
        }
    }
    Shopify.queryParams.sort_by = selectedValue.value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();

    // const filterForm = $('collection-filter form');
    // const sortBy = filterForm.find('[type="hidden"]');
    // sortBy.val(selectedValue.value);
    // filterForm.find('button[type="submit"]').click();
})
$(document).on('click', '.quantity-box__button', function () {
    const event = new Event('countChange');
    $(this).closest('.quantity-box__wrap').find($('input'))[0].dispatchEvent(event);
});
$(document).on('change', '.js-quantity-input', function () {
    const event = new Event('countChange');
    $(this)[0].dispatchEvent(event);
});


function Update_cart_count() {
    jQuery.getJSON('/cart.js', function (cart) {
        $('.js-cart-count-text')[0].innerHTML = cart.item_count;
        $('.js-cart-count')[0].removeAttribute("style")
    });
}

function updateCartPopup(productForm) {
    Update_cart_count();
    $('#cart-form').addClass('loading');
    fetch(window.routes.cart_url + '/?section_id=ajax-cart-popup').then(function (response) {
        return response.text();
    }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        const cart = $(doc).find('#cart-form .cart-modal__inner')[0].innerHTML;

        $(document).find('#cart-form .cart-modal__inner')[0].innerHTML = cart;
        if (productForm == true) {
            $('.js-cart-title')[0].innerHTML = window.cartStrings.success;
        }
        reloadEvents();
       Currency.convertAll(Currency.shopCurrency, Currency.currentCurrency);
        $('#cart-form').removeClass('loading');
    }).catch(function (err) {

        console.error('Something went wrong.', err);
    });
}

function reloadEvents() {
    var $block = $('.quantity-box');
    if (!$block.length) {
        return;
    }
    $block.each(function () {
        var $thisBlock = $(this);
        var $control = $thisBlock.find('.quantity-box__button');
        var $field = $thisBlock.find('.quantity-box__value');
        var count = parseInt($field.val());

        $field.on('input', function (e) {
            if (e.target.value <= 0) {
                $field.val('1');
            }
            $field.val(e.target.value.replace(/[, .]/g, ''));
        });

        $control.on('click', function () {
            if ($(this).is('.quantity-box__button_plus')) {
                count += 1;
            }
            if ($(this).is('.quantity-box__button_minus') && count > 1) {
                count -= 1;
            }
            $field.val(count);
        });
    });
}

$(document).on('click','.js-team-read-more',function (e){
    const modalId = $(this).attr('data-modal-id');
    const modal = $(`#${modalId}`);
    const item =  $(this).closest('.js-team-item');
    const name = item.find('.slide-card__title');
    const lable = item.find('.slide-card__label');
    const text = item.find('.modal-text');

    modal.find('.inform-modal__title')[0].innerHTML=name[0].innerHTML;
    modal.find('.inform-modal__subtitle')[0].innerHTML=lable[0].innerHTML;
    modal.find('.inform-modal__text')[0].innerHTML=text[0].innerHTML;
    $('.js-popup-triger')[0].click();
})
$('.js-search-sort-by').on('change',function (){
    const value = $(this).val();
    Shopify.queryParams = {};
    if (location.search.length) {
        var params = location.search.substr(1).split('&');

        for (var i = 0; i < params.length; i++) {
            var keyValue = params[i].split('=');

            if (keyValue.length) {
                Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
            }
        }
    }
    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
});
$(function () {
    var $block = $('.js-validation-wrap');
    if (!$block) {
        return;
    }
    var $button = $block.find('button:not([name="decline"])');
    $button.on('click',function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var validation = true;
        form.find('[required]').each(function () {
            if ($(this).val() === '') {
                validation = false;
                $(this).closest('.form-group').addClass('has-error');
            }
        });
        form.find('select[required]').each(function () {
            if (!form.find('option:selected').text().length) {
                validation = false;
                form.closest('.form-group').addClass('has-error');
            }
        });
        form.find('input[type="email"]').each(function () {
            var emailReg = void 0;
            if ($(this).val() !== '') {
                emailReg = /^.+@.+\..+$/;
                if (!emailReg.test($(this).val())) {
                    validation = false;
                    $(this).closest('.form-group').addClass('has-error');
                }
            }
        });
        if (validation) {
            var $formWrap = form.closest('.js-validation-wrap');
            $formWrap.addClass('submitting');
            setTimeout(function () {
                $formWrap.removeClass('submitting').addClass('submitted');
            }, 1000);
            form.trigger('submit')
            return form.trigger('validation-submit', form);
        }
        return form.trigger('validation-error', form);
    });
    $(document).on('click focus', '.has-error input, .has-error textarea', function (e) {
        $(e.currentTarget).closest('.has-error').removeClass('has-error');
    });
    var $this = $(this);
    if ($this.find('.validation-wrap').hasClass('submitted')) {
        $this.find('form').get(0).reset();
    }
    $this.find('.has-error').removeClass('has-error');
    $this.find('.validation-wrap').removeClass('submitted');
});

$('.js-product-rating').on('DOMSubtreeModified',function (){
    
   $('.js-review-link').show();
   const reviewLink = $('.js-review-link');
   const star = $(this).closest('.product-page-wrapper').find('.js-product-rating .loox-rating span');
   if(star.length>0){
       reviewLink.find('.card-thumbs__item-count')[0].innerHTML= `(${star[0].innerHTML.replace("reviews","").replace("&nbsp;","").trim()})`
   }
})
$('.js-replacement-back').on('click',function (e){
    $(this).closest('.replacement-box').removeClass('replacement-box_step-2');
    $(this).closest('.replacement-box').find('.replacement-box__search').trigger("reset");
    $(this).closest('.replacement-box__wrap').removeClass('show-results');
})
$('.cart-box__quantity .quantity-box__button').on('click',function (){
    const _this = $(this)
    setTimeout(function (){
        let value = parseInt(_this.closest('.cart-box__quantity').find('.quantity-box__value').val())
        if(value > 1){
            _this.closest('.cart-box__quantity').find('.quantity-box__button.quantity-box__button_minus').removeClass('hide-button');
        }else{
            _this.closest('.cart-box__quantity').find('.quantity-box__button.quantity-box__button_minus').addClass('hide-button');
        }
    },100)

})
$('.js-country-select').on('change', function (){
    let languageCode = `/${Shopify.locale}`
    if($(this).val() == 'us'){
        window.location.href = 'https://woodtrick.com'+location.pathname.replace(languageCode, "")+'?SkipCozyRedirect=yes'
    }else if($(this).val() == 'eu'){
        window.location.href = 'https://eu.woodtrick.com'+location.pathname
    }
});

/*custom dropdown*/
const selectedAll = document.querySelectorAll(".wrapper-dropdown");
if(selectedAll){
    var $showHideBlockDesktop = $('[data-show-hide-desktop]');
    var $showHideBlockMobile = $('[data-show-hide-mobile]');
    var customHideBlock = function hideBlock(block) {
        $(block).css({ opacity: 0, visibility: 'hidden' });
    };
    var customShowBlock = function showBlock(block) {
        let showBlock = true;
        $('select.select2.select2_lang').each(function () {
            if ( $(this).data('select2').isOpen()) {
                showBlock = false;
            }
        });
        if(showBlock){
            $(block).css({ opacity: 1, visibility: 'visible' });
        }
    };
    selectedAll.forEach((selected) => {
        const optionsContainer = selected.children[2];
        const optionsList = selected.querySelectorAll("div.wrapper-dropdown li");
        selected.addEventListener("click", () => {
            let arrow = selected.children[1];

            if (selected.classList.contains("active")) {
                handleDropdown(selected, arrow, false);
                var windowWidth = $(window).innerWidth();
                // eslint-disable-next-line no-unused-expressions
                setTimeout(function (){
                    windowWidth <= 767 ? customShowBlock($showHideBlockMobile) : customShowBlock($showHideBlockDesktop);
                },100)
            } else {
                let currentActive = document.querySelector(".wrapper-dropdown.active");

                if (currentActive) {
                    let anotherArrow = currentActive.children[1];
                    handleDropdown(currentActive, anotherArrow, false);
                }

                handleDropdown(selected, arrow, true);

                var windowWidth = $(window).innerWidth();
                // eslint-disable-next-line no-unused-expressions
                windowWidth <= 767 ? customHideBlock($showHideBlockMobile) : customHideBlock($showHideBlockDesktop);
            }
        });
    });

// check if anything else ofther than the dropdown is clicked
    window.addEventListener("click", function (e) {
        if (e.target.closest(".wrapper-dropdown") === null) {
            closeAllDropdowns();
        }
    });

// close all the dropdowns
    function closeAllDropdowns() {
        const selectedAll = document.querySelectorAll(".wrapper-dropdown");
        selectedAll.forEach((selected) => {
            const optionsContainer = selected.children[2];
            let arrow = selected.children[1];

            handleDropdown(selected, arrow, false);
        });
        var windowWidth = $(window).innerWidth();
        setTimeout(function (){
            windowWidth <= 767 ? customShowBlock($showHideBlockMobile) : customShowBlock($showHideBlockDesktop);
        },100)
    }

// open all the dropdowns
    function handleDropdown(dropdown, arrow, open) {
        if (open) {
            arrow.classList.add("rotated");
            dropdown.classList.add("active");
        } else {
            arrow.classList.remove("rotated");
            dropdown.classList.remove("active");
        }
    }
}
function setCurrentCountry(){
    let locationSearch = window.location.search;
    if(locationSearch.includes('redirectCountry=')){
        let locationSearchCountry = decodeURIComponent(window.location.search.split('&redirectCountry=')[1].split('&')[0])
        if(locationSearchCountry != ''){
            if(localStorage.getItem('CurrentCountryWoodTrickEU') ){
                if(localStorage.getItem('CurrentCountryWoodTrickEU') != locationSearchCountry){
                    localStorage.setItem('CurrentCountryWoodTrickEU', JSON.stringify(locationSearchCountry));
                }
            }else{
                localStorage.setItem('CurrentCountryWoodTrickEU', JSON.stringify(locationSearchCountry));
            }
        }
        window.history.replaceState({ }, '', window.location.href.split('&redirectCountry=')[0]);
    }
    if(localStorage.getItem('CurrentCountryWoodTrickEU') ){
        let currentCountry = JSON.parse(localStorage.getItem('CurrentCountryWoodTrickEU'));
        if(document.querySelector('.js-current-country-value')){
            document.querySelector('.js-current-country-value').innerHTML = `${currentCountry} <span class="arrow"></span>` ;
        }
    }
}
setCurrentCountry()
$('.js-collection-reviews-slider').not('.slick-initialized').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"><span class="slick-arrow-icon icon-arrow-left"></span></button>',
    nextArrow: '<button type="button" class="slick-next"><span class="slick-arrow-icon icon-arrow-right"></span></button>',
    dots: true,
    centerMode: false,
    responsive: [
        {
            breakpoint: 1240,
            settings: {
                slidesToShow: 3,
                centerMode: false
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                centerMode: false,
                arrows: false,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                centerMode: false,
                arrows: false,
            }
        }, {
            breakpoint: 540,
            settings: {
                slidesToShow: 1,
                centerMode: false,
                arrows: false,
            }
        }
    ]
});
$('.js-collection-reviews-slider.slick-initialized').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.js-collection-reviews-slider .video-poster').each(function (){
        let video = $(this).closest('.review-item-media').find('video');
        if(video.length > 0){
            video[0].pause();
            $(this).show();
        }
    })
});
$('.js-collection-reviews-slider .review-item-media').on("click", function (){
    let video = $(this).find('video');
    if($(this).hasClass('is-playing')){
        if(video.length > 0){
            video[0].pause();
            $(this).closest('.review-item-media').find('.video-poster').show();
        }
    }else{
        if(video.length > 0){
            video[0].play();
            $(this).closest('.review-item-media').find('.video-poster').hide();
        }
    }
    $(this).toggleClass('is-playing');
})
$( ".site-description__text table" ).wrap( "<div class='site-description__table-wrapper'></div>" );

let replacementSearchNext = document.querySelector(".js-replacement-search-next");
if(replacementSearchNext){
    replacementSearchNext.addEventListener('click',function (){
        checkReplacmentRule()
    })
}
function checkReplacmentRule(){
    let replacementInformBox = document.querySelector('.js-replacement-inform-box');
    let replacementForm = document.querySelector('.replacement-form-wrapper');
    let replacementReasonSelect = replacementForm.querySelector('.js-replacement-reason');
    let replacementReasonId = replacementReasonSelect.options[replacementReasonSelect.selectedIndex].value;
    if(replacementInformBox && replacementForm.dataset.showReplacment == "false"){
        if(replacementReasonId == 1 || replacementReasonId == 2 || replacementReasonId == 5){
            if(replacementForm){
                replacementForm.remove();
            }
            replacementInformBox.removeAttribute('style');
            window.history.replaceState({ }, '', window.location.href.replace('?step=2',''));
        }
    }
}